<ng-container *ngIf="totalRecords > 0; else elseTemplate">
    <ul class="pagination" style="height: 75px;" *ngIf="!isLoading && totalCount > size">
        <!-- Prev -->
        <li class="page-item">
            <button type="button" class="page-link" [disabled]="disabled || isFirstPage()"
                (click)="goToPage(currentPage - 1)">
                {{ 'Previous' | translate }}
            </button>
        </li>

        <!-- First + ... -->
        <li class="page-item" *ngIf="pages[0] > 1">
            <button class="page-link" (click)="goToPage(1)">1</button>
        </li>

        <!-- Dynamic Pages -->
        <li class="page-item" *ngFor="let page of pages">
            <button type="button" class="page-link" [ngClass]="{'text-bg-primary': currentPage === page}"
                [disabled]="disabled || currentPage === page" (click)="goToPage(page)">
                {{ page }}
            </button>
        </li>

        <!-- ... + Last -->
        <li class="page-item" *ngIf="pages[pages.length - 1] < totalPages">
            <button class="page-link" [disabled]="disabled" (click)="goToPage(totalPages)">
                {{ totalPages }}
            </button>
        </li>

        <!-- Next -->
        <li class="page-item">
            <button type="button" class="page-link" [disabled]="disabled || isLastPage()"
                (click)="goToPage(currentPage + 1)">
                {{ 'Next' | translate }}
            </button>
        </li>
    </ul>
</ng-container>
<ng-template #elseTemplate>
    <app-no-results [isLoading]="isLoading" [totalRecords]="totalRecords"></app-no-results>
</ng-template>